import { IBaseModel } from "../BaseModel";

export enum ApplicationStatus {
  Archived,
  Disabled,
  Enabled,
  Preview,
}

export enum ApplicationVisability {
  Public,
  Private,
}

export interface IApplication extends IBaseModel {
  name: string;
  system: boolean;
  allowSignup: boolean;
  status: ApplicationStatus;
  visability: ApplicationVisability;
  systemApplicationSettingsConnectionString: string;
}
